export const reviews = [
  {
    name: "Ravi Sharma",
    title: "Amazing App for Deals",
    rating: 4.5,
    date: "January 15, 2025",
    content:
      "Great app for finding deals! Combines discounts from various stores into one place. Saves me time and effort. Highly recommended!",
  },
  {
    name: "Meera Patel",
    title: "Perfect for Online Shopping",
    rating: 4.3,
    date: "March 10, 2025",
    content:
      "The app is amazing for price tracking and offers. It’s better than shopping directly from other sites. So convenient and helpful!",
  },
  {
    name: "Aditya Joshi",
    title: "Superb Shopping Companion",
    rating: 4.7,
    date: "April 25, 2024",
    content:
      "Love how the app feels like a Telegram group but with all the deals in one place. Super easy and fun to use for online shopping!",
  },
  {
    name: "Priya Verma",
    title: "A Must-Have App",
    rating: 4.2,
    date: "June 12, 2024",
    content:
      "This app saved me from falling for fake sales! The price graph is a game-changer. Never shopping without it again.",
  },
  {
    name: "Vikas Singh",
    title: "Highly Recommended!",
    rating: 4.8,
    date: "August 8, 2024",
    content:
      "Simple and effective! Always shows the best deals and notifies me for discounts I care about. Shopping is now hassle-free.",
  },
  {
    name: "Aarti Nair",
    title: "Saved Me So Much!",
    rating: 4.4,
    date: "September 20, 2024",
    content:
      "Saved a ton on shoes and phone cases. This app makes sure I never miss deals. Wish I had found it earlier!",
  },
  {
    name: "Rohan Das",
    title: "Perfect for Bargain Hunters",
    rating: 4.6,
    date: "October 5, 2024",
    content:
      "Brings all discounts together in one spot. No need to search endlessly for deals anymore. Shopping is fun and easy now!",
  },
  {
    name: "Ananya Kulkarni",
    title: "Game-Changer for Online Shopping",
    rating: 4.9,
    date: "December 1, 2024",
    content:
      "This app has changed how I shop online. Everything I need is in one place, saving me both time and money. Love it!",
  },
  {
    name: "Kavita Reddy",
    title: "Best App for Smart Shoppers",
    rating: 4.8,
    date: "February 14, 2025",
    content:
      "Tracks price drops and finds great deals. It's like having a personal shopping assistant. Can’t shop without it anymore!",
  },
  {
    name: "Arjun Mehta",
    title: "Simplifies Online Shopping",
    rating: 4.1,
    date: "May 9, 2024",
    content:
      "Brings the best deals to one place. The price tracking feature is so useful. Shopping has never been easier!",
  },
  {
    name: "Nisha Gupta",
    title: "Convenient and Reliable",
    rating: 4.3,
    date: "July 18, 2024",
    content:
      "A must-have for online shoppers. Finds discounts quickly and saves time. Great for gadgets, clothes, and more!",
  },
  {
    name: "Manoj Kumar",
    title: "Exceptional App for Deals",
    rating: 3.9,
    date: "November 2, 2024",
    content:
      "Simple and effective. The price graph feature is the best! Helps me save on every purchase. Highly reliable.",
  },
];
